module.exports = __webpack_public_path__ + "img/lv.f585c7ec.svg";